import { useCallback } from 'react';
import { cratChain, tap2mineContract } from 'shared';
import { useAccount, useSwitchChain } from 'wagmi';

interface UseAddNftProps {
  chainId?: number;
}

export const useAddNft = (props?: UseAddNftProps) => {
  const { chainId = cratChain.id } = props ?? {};
  const { switchChainAsync } = useSwitchChain();

  const { connector, chainId: currentChainId } = useAccount();

  const addToWallet = useCallback(
    async (tokenId: string | number) => {
      try {
        if (currentChainId !== chainId) {
          await switchChainAsync({ chainId });
        }

        const provider = await connector?.getProvider({ chainId });

        // @ts-expect-error: provider typing
        if (!provider?.request) {
          console.warn('Provider does not support request method');
          return;
        }

        // @ts-expect-error: provider typing
        await provider?.request({
          method: 'wallet_watchAsset',
          params: {
            type: 'ERC1155',
            options: {
              address: tap2mineContract.address,
              tokenId: tokenId.toString(),
            },
          },
        });
      } catch (error) {
        console.error('Failed to watch NFT asset:', error);
      }
    },
    [chainId, connector, currentChainId, switchChainAsync],
  );

  return {
    canAdd: connector && connector?.name.toLowerCase() === 'metamask',
    addToWallet,
  };
};
